(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/views/result-detail.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/views/result-detail.js');

'use strict';

svs.numbergames.results.views.ResultDetail = Marionette.View.extend({
  ballRow: undefined,
  className() {
    const product = svs.numbergames.productMapping.getProductName(this.model.get('productId'));
    return "ng-".concat(product.toLowerCase(), "-result-details");
  },
  regions() {
    const regions = {
      correctRowRegion: '#correctRowRegion',
      payoutRegion: '#payoutRegion'
    };
    if (this.options.model.get('productId') !== 'LOTTO') {
      regions.peppbubblesRegion = '#peppbubblesRegion';
    }
    return regions;
  },
  ui: {
    sortSelect: '.js-sort-select'
  },
  triggers: {
    'change @ui.sortSelect': 'changeSorting'
  },
  template(data) {
    return svs.numbergames.results.templates.result_detail(data);
  },
  templateContext() {
    return {
      radioGroupName: "ng-sort-numbers-".concat(this.model.get('productId').toLowerCase(), "-").concat(this.model.has('type') ? this.model.get('type') : '')
    };
  },
  initialize() {
    const branding = svs.numbergames.productMapping.getProductName(this.model.get('productId'));
    let ballRow = svs.tur.ball.row.result[branding];
    if (!ballRow) {
      ballRow = svs.tur.ball.row.result.Default;
    }
    this.ballRow = new ballRow({
      numbers: this.model.get('numbers'),
      extraNumbers: this.model.get('numbersExtra'),
      kungKeno: this.model.get('kungKenoNumber')
    });
  },
  onRender() {
    const productId = this.model.get('productId');
    this.showChildView('correctRowRegion', {
      template: () => this.ballRow.render()
    });
    if (productId !== 'LOTTO' && productId !== 'JOKER') {
      this.showChildView('peppbubblesRegion', new svs.numbergames.results.views.Peppbubbles({
        model: this.model
      }));
    }
    if (productId === 'KENO') {
      this.showChildView('payoutRegion', new svs.numbergames.results.views.PayoutTables({
        model: this.model
      }));
    } else {
      this.showChildView('payoutRegion', new svs.numbergames.results.views.PayoutTable({
        model: this.model.get('payout')
      }));
    }
  },
  onAttach() {
    if (this.model.get('productId') !== 'JOKER') {
      this.triggerMethod('change:sorting');
    }
  },
  onChangeSorting(view) {
    let {
      target: {
        value = 'NUMERICAL'
      } = {}
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const sortOrder = svs.tur.ball.row.sorter.constants[value];
    this.ballRow.sort(sortOrder);
  }
});

 })(window);